export default {
    url: 'support-for-disaster-prevention',
    include: ['jp'],
}